// Environment-specific configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://147.79.74.253:5001';
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;

// Other configuration exports
export const AUTH_TOKEN_KEY = 'token';
export const USER_DATA_KEY = 'userData'; 